module.exports = __webpack_public_path__ + "img/UTANAS-4.72b45f1a.jpg";